import React from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Formik, Form } from 'formik';
import PropTypes from 'prop-types';

import NewDesign from 'components/NewDesign';
import Profile from 'pages/Settings/Tabs/Profile';
import actions from 'redux/actions';
import getUser from 'redux/selector/getUser';
import UserModel from 'models/user.model';
import { validationProfile } from 'consts/validateSchema';

const propTypes = {
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  className: PropTypes.string,
};

const { updateProfileUser } = actions;

const DialogUpdateProfile = (props) => {
  const { isOpen, toggle, className, onSuccess } = props;
  const dispatch = useDispatch();
  const userInfo = getUser();

  const onSubmit = (values, { setSubmitting }) => {
    dispatch(
      updateProfileUser({
        ...values,
        callbacks: {
          onSuccess: () => {
            onSuccess && onSuccess();
            setSubmitting(false);
            toggle();
          },
          onFailed: () => {
            setSubmitting(false);
          },
        },
      })
    );
  };

  return (
    <Formik
      validationSchema={validationProfile}
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={{
        ...UserModel.initialProfileUser(userInfo),
      }}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {(propsFormik) => (
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          className={className}
          backdrop={propsFormik.isSubmitting ? 'static' : true}
          style={{ maxWidth: '100%' }}
        >
          <Form>
            <ModalHeader toggle={toggle}>Update Information</ModalHeader>

            <ModalBody>
              <Profile />
            </ModalBody>

            <ModalFooter>
              <NewDesign.Button type='submit' isLoading={propsFormik.isSubmitting}>
                Update
              </NewDesign.Button>
              <NewDesign.Button variant='text' type='button' className='btn' onClick={toggle}>
                Close
              </NewDesign.Button>
            </ModalFooter>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

DialogUpdateProfile.propTypes = propTypes;
export default DialogUpdateProfile;
